import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class TimeTrackingWithIcon extends Field {
  static subqueriesForModel() {
    return { bestEstimate: ['text'] };
  }

  get title() {
    return 'Best estimate with icon';
  }

  exampleContents(): FieldContentsData {
    return {
      prefix: 'B',
      text: '2d',
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.bestEstimate?.text) {
      return {
        prefix: 'B',
        text: record.bestEstimate.text,
      };
    }

    return {};
  }
}
